export const AFFIRM_LOCALE_CONFIG = {
  US: { country_code: "USA", locales: ["en_US"], default_locale: "en_US" },
  CA: {
    country_code: "CAN",
    locales: ["en_CA", "fr_CA"],
    default_locale: "en_CA",
  },
} as const;
